import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDataEncryption } from '../utils/offlineDataEncryption/OfflineDataEncryption.util';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { PageParams } from './offlineOrders.repository';

export const offlinePacksRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.packs),

  page: async ({ limit, skip, query, ids }: PageParams & { ids?: string[] }) => {
    let collection = offlineDatabase.packs.toCollection();

    if (ids && ids.length > 0) {
      collection = collection.and((pack) => ids.includes(pack.id));
    }

    if (query) {
      const offlineDataEncryption = new OfflineDataEncryption();

      collection = collection.filter((pack) => {
        const decryptedName = offlineDataEncryption.decryptOfflineData({
          input: pack.name,
        });

        return decryptedName.toLowerCase().startsWith(query.toLowerCase());
      });
    }

    const count = await collection.count();

    if (skip) {
      collection = collection.offset(skip);
    }

    if (limit) {
      collection = collection.limit(limit);
    }

    const data = await collection.toArray();

    return { count, data };
  },
};
